import React from 'react';
import styled from "styled-components";

const SelectTabPanel = styled.div<{ isSidebarOpen: boolean; fullscreen: boolean }>`
  display: flex;
  align-items: center;
  height: 42px;
  padding-left: 31px;
  margin-left: ${({ fullscreen, isSidebarOpen }) =>
  isSidebarOpen && !fullscreen ? '255px' : ''};
`;

interface IProps {
  isSideBarOpen: boolean;
  fullscreen: boolean;
  children: React.ReactNode;
}

const PageTabSelection = ({ isSideBarOpen, fullscreen, children }: IProps) => {
  return (
    <SelectTabPanel isSidebarOpen={isSideBarOpen} fullscreen={fullscreen}>
      {children}
    </SelectTabPanel>
  );
};

export default PageTabSelection;